import { Card, CardContent, Grid, Stack, Typography } from '@mui/material';

import { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { Link } from 'react-router-dom';

import PageTitle from 'components/PageTitle/PageTitle';

import { ReactComponent as NoActivityIcon } from 'common/assets/images/NoActivity.svg';
import Breadcrumbs from 'common/components/Breadcrumbs/Breadcrumbs';
import ButtonComp from 'common/components/Button/ButtonComp';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import { TestScriptHubText } from 'common/constants/TextContent';
import { RootState } from 'common/store/AppStore';
import { setControlTestClicked } from 'common/store/reducer/controlTestScriptReducer';
import {
	scrollToTop,
	toSentenceCase,
	urlWithTenant,
} from 'common/utils/utilFunctions';

import commonStyles from 'features/common/Common.module.scss';

import ControlTestSelectionLandingPage from './ControlTestSelection/ControlTestSelectionLandingPage';

import styles from './TestScriptHubLandingPage.module.scss';

const TestScriptHubLandingPage = () => {
	const dispatch = useDispatch();

	const controlTestClicked = useSelector(
		(state: RootState) => state.controlTestScript.controlTestClicked,
	);

	const breadcrumbs = [
		<Link key="1" to={urlWithTenant(`/${rrcpDashboardRoutes.testing}`)}>
			{toSentenceCase('Testing & Monitoring')}
		</Link>,
		<Typography key="2">{toSentenceCase('Test Script Hub')}</Typography>,
	];
	useEffect(() => {
		scrollToTop();
	}, []);

	const navigateToSelection = () => {
		dispatch(setControlTestClicked(true));
	};
	return (
		<Grid>
			{!controlTestClicked ? (
				<div className={commonStyles['page-background']}>
					<Grid container>
						<Grid item>
							<Breadcrumbs breadcrumbs={breadcrumbs} />
							<PageTitle text={TestScriptHubText} />
						</Grid>
						<Grid item className={styles['test-script-hub-container']}>
							<div
								className={`${commonStyles['main-tabs-box']}
									}`}
							>
								<Grid
									container
									spacing={2}
									className={`${commonStyles['landing-grid-style']}`}
								>
									<Card className={styles['card-container']}>
										<CardContent>
											<Typography className={styles['test-script-hub-title']}>
												{toSentenceCase('Test Type Selection')}
											</Typography>
											<Grid container spacing={2}>
												<Grid
													item
													xs={4}
													sm={4}
													md={4}
													lg={4}
													xl={4}
													className={styles['test-hub-btn-container']}
												>
													<Stack spacing={2}>
														<ButtonComp
															clickHandler={navigateToSelection}
															btnType="secondary"
															data-testid="control-test-btn"
														>
															Control test
														</ButtonComp>
														<ButtonComp
															btnType="secondary"
															data-testId="obt-test-btn"
														>
															OBT test
														</ButtonComp>
													</Stack>
												</Grid>
												<Grid
													item
													xs={8}
													sm={8}
													md={8}
													lg={8}
													xl={8}
													className={styles['test-script-side-container']}
												>
													<Stack className={styles['test-script-stack']}>
														<Typography className={styles['no-activity-text']}>
															Please select your test type.
														</Typography>
														<NoActivityIcon
															className={styles['no-activity-img']}
														/>
													</Stack>
												</Grid>
											</Grid>
										</CardContent>
									</Card>
								</Grid>
							</div>
						</Grid>
					</Grid>
				</div>
			) : (
				<div>
					<ControlTestSelectionLandingPage
						secondLevelBreadcrumbs={breadcrumbs}
					/>
				</div>
			)}
		</Grid>
	);
};

export default TestScriptHubLandingPage;
